import { IRepertoireFilter } from '../../interfaces/repertoire.interface';

export class SetRepertoire {
    public static readonly type = '[Repertoire] set';
}

export class SetRepertoireSearch {
    public static readonly type = '[Repertoire] search';
    constructor(public searchValue: string) {}
}

export class SetRepertoireFilter {
    public static readonly type = '[Repertoire] filter';
    constructor(public filters: IRepertoireFilter[]) {}
}

export class ResetRepertoire {
    public static readonly type = '[Repertoire] reset state';
}

export class SetCurrentScrollLetter {
    public static readonly type = '[Repertoire] set scroll letter';
    constructor(public letter: string) {}
}
